"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var KEYS = require('../../constants/keyCodes');

var _ = require('lodash');

var React = require('react');

var BaseButton = require('../button.js');

var CancelSymbol = require('../x.svg.js');

var OkSymbol = require('../check.svg.js');

var TextInput = require('../textInput');

var getFirstInvalidValidator = function getFirstInvalidValidator(value, validators) {
  return _.find(validators, function (_ref) {
    var validator = _ref.validator;
    return !validator(value);
  });
};

var InputWithConfirm = function InputWithConfirm(props) {
  var ignoreBlurOnce = false;

  var _React$useState = React.useState(props.value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      editMode = _React$useState4[0],
      setEditMode = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isValid = _React$useState6[0],
      setIsValid = _React$useState6[1];

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      invalidMessage = _React$useState8[0],
      setInvalidMessage = _React$useState8[1];

  var getClassNames = function getClassNames() {
    return props.getClassName('control-input-with-confirm');
  };

  var setInitialValidState = function setInitialValidState() {
    setValue(props.value);
    var initialInvalidValidator = getFirstInvalidValidator(props.value, props.validators);
    setIsValid(!initialInvalidValidator);
    setInvalidMessage(initialInvalidValidator && initialInvalidValidator.invalidMessage);
  };

  React.useEffect(function () {
    setInitialValidState();
  }, ['value', 'validators']);

  var doCancel = function doCancel() {
    var andCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _.noop;
    setEditMode(false);
    setInitialValidState();
    andCallback();
    props.onCancel();
  };

  var doApply = function doApply() {
    var andCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _.noop;
    setEditMode(false);
    andCallback();
    props.onChange(value);
  };

  var onCancelClick = function onCancelClick() {
    doCancel();
  };

  var onApplyClick = function onApplyClick() {
    doApply();
  };

  var onInputFocus = function onInputFocus() {
    setEditMode(true);
  };

  var onInputBlur = function onInputBlur(_ref2) {
    var relatedTarget = _ref2.relatedTarget;

    // We only want to apply/cancel the value in case:
    // 1. We did not come here after a keyDown
    // 2. We did not come here after clicking on apply/cancel button
    if (ignoreBlurOnce) {
      ignoreBlurOnce = false;
    } else if (!(relatedTarget && relatedTarget.classList.contains('input-with-confirm-btn'))) {
      if (props.changeOnBlur) {
        doApply();
      } else {
        doCancel();
      }
    }
  };

  var onInputChange = function onInputChange(newValue) {
    var invalidValidator = getFirstInvalidValidator(newValue, props.validators);
    setValue(newValue);
    setIsValid(!invalidValidator);
    setInvalidMessage(invalidValidator && invalidValidator.invalidMessage);
  };

  var onInputKeyDown = function onInputKeyDown(_ref3, blur) {
    var keyCode = _ref3.keyCode;

    if (keyCode === KEYS.ENTER) {
      doApply(function () {
        ignoreBlurOnce = true;
        blur();
      });
    } else if (keyCode === KEYS.ESC) {
      doCancel(function () {
        ignoreBlurOnce = true;
        blur();
      });
    }
  };

  var getButtonClasses = function getButtonClasses(applyButtonPriority) {
    var basic = 'btn-md btn-round input-with-confirm-btn';

    if (applyButtonPriority.toLowerCase() === 'primary') {
      return basic;
    }

    return 'btn-light ' + basic;
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-aid": props.automationId,
    "data-hook": props.dataHook,
    className: getClassNames()
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: value,
    placeholder: props.placeholder,
    maxLength: props.maxLength,
    focus: props.focus,
    selectOnFocus: props.selectOnFocus,
    blurOnEnterKey: false,
    blurOnEscKey: false,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    onKeyDown: onInputKeyDown,
    onChange: onInputChange,
    isValid: isValid,
    invalidMessage: invalidMessage
  }), editMode && /*#__PURE__*/React.createElement("div", {
    className: "buttons-container",
    key: "buttonsContainer"
  }, /*#__PURE__*/React.createElement(BaseButton, {
    automationId: "input-with-confirm-btn-cancel",
    className: 'btn-light btn-md btn-round input-with-confirm-btn',
    onClick: onCancelClick,
    key: "cancel"
  }, /*#__PURE__*/React.createElement(CancelSymbol, null)), /*#__PURE__*/React.createElement(BaseButton, {
    automationId: "input-with-confirm-btn-apply",
    className: getButtonClasses(props.applyButtonPriority),
    disabled: !isValid,
    onClick: onApplyClick,
    key: "apply"
  }, /*#__PURE__*/React.createElement(OkSymbol, null))));
};

InputWithConfirm.displayName = displayNames.INPUT_WITH_CONFIRM;
InputWithConfirm.propTypes = {
  /** Automation ID */
  automationId: PropTypes.string,

  /** Textual value for input field */
  value: PropTypes.string,

  /** Placeholder */
  placeholder: PropTypes.string,

  /** Maximum length of input field */
  maxLength: PropTypes.number,

  /** Is input field focused on component first render */
  focus: PropTypes.bool,

  /** Is the input field content automatically selected on focus */
  selectOnFocus: PropTypes.bool,

  /** Should a change or cancel event be triggered on clicking outside of the component */
  changeOnBlur: PropTypes.bool,

  /** On change callback */
  onChange: PropTypes.func,

  /** On cancel callback */
  onCancel: PropTypes.func,

  /** List of validators */
  validators: PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  })),

  /** Priority of the apply button */
  applyButtonPriority: PropTypes.oneOf(['primary', 'secondary'])
};
InputWithConfirm.defaultProps = {
  value: '',
  placeholder: '',
  focus: false,
  selectOnFocus: false,
  changeOnBlur: true,
  onChange: _.noop,
  onCancel: _.noop,
  validators: [],
  applyButtonPriority: 'secondary'
};
module.exports = compose(InputWithConfirm);